/* global angular */

(function() {
  "use strict";

  var app = angular.module('app');

  app.factory('Range', ['$timeout', function($timeout) {
    var ONEDAY = 24 * 60 * 60 * 1000;

    function Range() {
        this.today = getToday();
        this.first = this.getFirstDayOfWeek();
        this.last = this.getLastDayOfWeek();
        this.setCurrentDay();
        this.options = {
            minDate: getToday(),
            showWeeks: false,
            showButtonBar: false,
        };
    }

    Range.prototype = {
        getToday: getToday,
        getKey: getKey,
        getFirstDayOfWeek: getFirstDayOfWeek,
        getLastDayOfWeek: getLastDayOfWeek,
        trimDate: trimDate,
        set: set,
        setNextDays: setNextDays,
        setCurrentDay: setCurrentDay,
        setCurrentWeek: setCurrentWeek,
        isCurrentDay: isCurrentDay,
        isCurrentWeek: isCurrentWeek,
        setLastMonth: setLastMonth,
        isLastMonth: isLastMonth,
        setLastQuarter: setLastQuarter,
        isLastQuarter: isLastQuarter,
        setLastSemester: setLastSemester,
        isLastSemester: isLastSemester,
        setLastYear: setLastYear,
        isLastYear: isLastYear,
        open: open,
    };

    return Range;

    function set(from,to) {
        this.from = from;
        this.to = to;
    }

    function setNextDays(days) {
        this.set(this.today, new Date(this.today.getTime() + days * ONEDAY));
    }        

    function setCurrentDay() {
        this.from = this.to = this.today;
    }

    function setCurrentWeek() {
        this.from = this.first;
        this.to = this.last;
    }

    function isCurrentDay() {
        return getKey(this.from) === getKey(this.today) &&
                getKey(this.to) === getKey(this.today);
    }

    function isCurrentWeek() {
        return getKey(this.from) === getKey(this.first) &&
                getKey(this.to) === getKey(this.last);
    }

    function setLastMonth() {
        this.from = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
        this.to = this.today; // new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);
    }

    function setLastQuarter() {
        this.from = new Date(this.today.getFullYear(), this.today.getMonth() - 3, 1);
        this.to = this.today;
    }

    function setLastSemester() {
        this.from = new Date(this.today.getFullYear(), this.today.getMonth() - 6, 1);
        this.to = this.today;
    }

    function setLastYear() {
        this.from = new Date(this.today.getFullYear(), this.today.getMonth() - 12, 1);
        this.to = this.today; // new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);
    }

    function isLastMonth() {
        var first = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
        return getKey(this.from) === getKey(first) &&
                getKey(this.to) === getKey(this.today);
    }

    function isLastQuarter() {
        var first = new Date(this.today.getFullYear(), this.today.getMonth() - 3, 1);
        return getKey(this.from) === getKey(first) &&
            getKey(this.to) === getKey(this.today);
    }

    function isLastSemester() {
        var first = new Date(this.today.getFullYear(), this.today.getMonth() - 6, 1);
        return getKey(this.from) === getKey(first) &&
                getKey(this.to) === getKey(this.today);
    }

    function isLastYear() {
        var first = new Date(this.today.getFullYear(), this.today.getMonth() - 12, 1);
        return getKey(this.from) === getKey(first) &&
                getKey(this.to) === getKey(this.today);
    }

    function getToday() {
        return trimDate(new Date() < new Date(2017, 10, 16) ? new Date(2017, 10, 16) : new Date());
    }

    function getFirstDayOfWeek() {
        var diff = this.today.getDay();
        diff = (diff === 0 ? 6 : diff - 1);
        var date = new Date(this.today);
        date.setDate(date.getDate() - diff);
        return trimDate(date);
    }

    function getLastDayOfWeek() {
        var diff = this.today.getDay();
        diff = (diff === 0 ? 6 : diff - 1);
        var date = new Date(this.today);
        date.setDate(date.getDate() - diff + 7);
        return trimDate(date);
    }

    function trimDate(date) {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        return date;
    }

    function getKey(date) {
        date = new Date(date);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        return Math.ceil(date.getTime() / ONEDAY);
    }

    function open(key) {
        this.flags = {};
        this.flags[key] = true;
    }

  }]);

}());